import fp from 'lodash/fp'

export const getSport = fp.flow(fp.split('_'), fp.join(', '), fp.capitalize)
